import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as types from 'misc/types';

class PopupButton extends Component {
    render = () => {
        const {key, label} = this.props;

        return (
            <button className='button-yellow button-ok' key={key} onClick={() => this.performAction()}>
                {label}
            </button>
        );
    };

    performAction() {
        const { dispatch, action } = this.props;
        dispatch({ type: types.POPUP_HIDE });
        dispatch(action);
    }
}

export default connect()(PopupButton);



// WEBPACK FOOTER //
// ./src/components/shared/popup/PopupButton.js